module.exports = "/_next/static/images/sr-658b680abffeef59fab1e3faef26b1d0.svg";